<template>
  <div class="box13">
    <img src="../../../assets/coursePage/linux/box13/img01.png"/>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
     
    };
  },
  computed: {
   
  },
};
</script>

<style lang="less" scoped>
.box13 {
 img{width: 100%;display: block;}
}
</style>
